import { Component, Input, OnInit } from '@angular/core';
import { ArrayDefinition } from '../../../../data/definitions';
import {
  DynamicListComponent,
  DynamicObjectComponent,
  DynamicTableComponent,
} from '@softline/dynamic';

import { ChipComponent } from '@softline/ui-core';

@Component({
  selector: 'soft-dynamic-array-value',
  templateUrl: './array.component.html',
  styleUrls: ['./array.component.css'],
  imports: [
    DynamicTableComponent,
    ChipComponent,
    DynamicObjectComponent,
    DynamicListComponent
],
})
export class ArrayComponent implements OnInit {
  @Input() values?: any[];
  @Input() definition?: ArrayDefinition;

  constructor() {}

  ngOnInit(): void {}
}
